import { Tile } from "../../../common/Tile";
import { compareObjects } from "../../../utils/compareObjects";

export const OptionalFeatures = ({ data }) => {
  const filteredFeatures = data?.features.result.filter((feature) => {
    const firstPart = feature.key.split('-')[0];
    return firstPart === "FO";
  });

  return !data ? (
    <div>Brak danych</div>
  ) : (
    <Tile
      data={{
        companyStatus: data.companyStatus,
        features: {
          tileHeader: "Konfiguracje Opcjonalne (w ramach godzin serwisowych)",
          optionalFeatures: true,
          result: filteredFeatures.sort(compareObjects),
        },
      }}
    />
  );
};
